import { Component, ElementRef, Input, OnChanges, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import * as d3 from 'd3';

import { DailyBurn } from '../types/daily-burn';

@Component({
  selector: 'hub-spend-chart',
  templateUrl: './hub-spend-chart.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./hub-spend-chart.component.css']
})
export class HubSpendChartComponent implements OnInit, OnChanges {
  @ViewChild('hubSpendChart', {static: true})
  private chartContainer: ElementRef;

  @Input()
  dailyBurnInfo : DailyBurn[]
  margin = { top: 20, right: 20, bottom: 30, left: 40 };
  monthNames = ["Jan", "Feb", "March", "April", "May", "June",
  "July", "Aug", "Sept", "Oct", "Nov", "Dec"];

  constructor() {}

  ngOnInit() {}

  ngOnChanges(): void {
    if (!this.dailyBurnInfo) { return; }

    this.createChart();
  }

  private createChart(): void {
    d3.select('svg').remove();
    const element = this.chartContainer.nativeElement;

    let data : {dateString: string, spend: number}[] = [];
    for(let index=this.dailyBurnInfo.length-1; index>=0; index--){
      if(this.dailyBurnInfo.length<=7){
        data.push({dateString: this.dailyBurnInfo[index].date.toDateString(), spend: this.dailyBurnInfo[index].spend});
      }else{
        data.push({dateString: this.dailyBurnInfo[index].date.getDate() + " " + this.monthNames[this.dailyBurnInfo[index].date.getMonth()], spend: this.dailyBurnInfo[index].spend});
      }
    }

    const svg = d3.select(element).append('svg')
      .attr('width', element.offsetWidth)
      .attr('height', element.offsetHeight);

    const contentWidth = element.offsetWidth*(7/8) - this.margin.left - this.margin.right;
    const contentHeight = element.offsetHeight - this.margin.top - this.margin.bottom;

    const x = d3
      .scaleBand()
      .rangeRound([0, contentWidth])
      .padding(0.1)
      .domain(data.map(d => d.dateString));

    let maxY = d3.max(data, d => d.spend);
    if (!maxY || maxY < 1) {
      maxY = 1;
    }
    const y = d3
      .scaleLinear()
      .rangeRound([contentHeight, 0])
      .domain([0, maxY]);

    // Should be able to set scale for y axis with something like...
    // chart.yAxis.scale().domain([0, maxValue]);


    var tooltip = d3.select("body").append("div").attr("class", "toolTip");

    const g = svg.append('g')
      .attr('transform', 'translate(' + this.margin.left + ',' + this.margin.top + ')');


    g.append('g')
      .attr('class', 'axis axis--x')
      .attr('transform', 'translate(0,' + contentHeight + ')')
      .call(d3.axisBottom(x));

    g.append('g')
      .attr('class', 'axis axis--y')
      .call(d3.axisLeft(y))
      .append('text')
      .attr('transform', 'rotate(-90)')
      .attr('y', 6)
      .attr('dy', '0.71em')
      .attr('text-anchor', 'end')
      .text('burntime');

    g.selectAll('.bar')
      .data(data)
      .enter().append('rect')
      .attr('class', 'bar')
      .attr('x', d => x(d.dateString))
      .attr('y', d => y(d.spend))
      .attr('width', x.bandwidth())
      .text('minutes')
      .attr('height', d => contentHeight - y(d.spend))
      .on("mousemove", function(d){
          tooltip
            .style("left", d3.event.pageX - 50 + "px")
            .style("top", d3.event.pageY - 70 + "px")
            .style("display", "inline-block")
            .html((d.dateString) + "<br>" + "Spend: €"+ ((d.spend / 100).toFixed(2)));
      })
      .on("mouseout", function(d){ tooltip.style("display", "none");
    });
  }

  onResize() {
    this.createChart();
  }
}
